import React, { Component } from 'react';
import { Modal, Table } from 'react-bootstrap';
import './profile.css';
import { DiscordContext } from '../../discord/DiscordContext';
import { getLocalDisplayName } from '../../hooks/useLocalDisplayName';


const STATS = [
    [ 'advertisement_actions_taken', 'Advertisement Actions Taken' ],
    [ 'attacks_to_lodging', 'Attacks to lodging' ],
    [ 'attacks_with_ghosts', 'Attacks with Ghosts' ],
    [ 'attacks_with_pirates', 'Attacks with Pirates' ],
    [ 'attacks_with_seekers', 'Attacks with Seekers' ],
    [ 'attacks_with_vanguards', 'Attacks with Vanguards' ],
    [ 'games_played', 'Games Played' ],
    [ 'games_played_as_deep', 'Games Played as Deep' ],
    [ 'games_played_as_dread', 'Games Played as Dread' ],
    [ 'games_played_as_hex', 'Games Played as Hex' ],
    [ 'games_played_as_honored', 'Games Played as Honored' ],
    [ 'games_played_as_seed', 'Games Played as Seed' ],
    [ 'games_played_as_stem', 'Games Played as Stem' ],
    [ 'games_started', 'Games Started' ],
    [ 'games_won', 'Games Won' ],
    [ 'games_won_as_deep', 'Games Won as Deep' ],
    [ 'games_won_as_dread', 'Games Won as Dread' ],
    [ 'games_won_as_hex', 'Games Won as Hex' ],
    [ 'games_won_as_honored', 'Games Won as Honored' ],
    [ 'games_won_as_seed', 'Games Won as Seed' ],
    [ 'games_won_as_stem', 'Games Won as Stem' ],
    [ 'ghost_actions_taken', 'Ghost Actions Taken' ],
    [ 'ghosts_received', 'Ghosts Received' ],
    [ 'lodging_actions_taken', 'lodging Actions Taken' ],
    [ 'pirates_received', 'Pirates Received' ],
    [ 'random_actions_taken', 'Random Actions Taken' ],
    [ 'renovation_actions_taken', 'Renovation Actions Taken' ],
    [ 'research_actions_taken', 'Research Actions Taken' ],
    [ 'robot_actions_taken', 'Robot Actions Taken' ],
    [ 'rounds_played', 'Rounds Played' ],
    [ 'satisfied_guests', 'Satisfied Guests' ],
    [ 'seekers_received', 'Seekers Received' ],
    [ 'turns_played', 'Turns Played' ],
    [ 'unsatisfied_pirates_received', 'Unsatisfied Pirates Received' ],
    [ 'unsatisfied_seekers_received', 'Unsatisfied Seekers Received' ],
    [ 'unsatisfied_vanguards', 'Unsatisfied Vanguards' ],
    [ 'vanguards_received', 'Vanguards Received' ],
];

// const STATS_NAMES = [
//     'Attacks with Seekers',
//     'Attacks with Vanguards',
//     'Games Played',
//     'Games Played as Deep',
//     'Games Played as Dread',
//     'Games Played as Hex',
//     'Games Played as Honored',
//     'Games Played as Seed',
//     'Games Played as Stem',
//     'Games Started',
//     'Games Won',
//     'Games Won as Deep',
//     'Games Won as Dread',
//     'Games Won as Hex',
//     'Games Won as Honored',
//     'Games Won as Seed',
//     'Games Won as Stem',
//     'Ghost Actions Taken',
//     'Ghosts Received',
//     'lodging Actions Taken',
//     'Pirates Received',
//     'Random Actions Taken',
//     'Renovation Actions Taken',
//     'Research Actions Taken',
//     'Robot Actions Taken',
//     'Rounds Played',
//     'Satisfied Guests',
//     'Seekers Received',
//     'Turns Played',
// ]


const STAT_TRANSLATOR = {
    'advertisement_actions_taken': 'Advertisement Actions Taken',
};


export class MemberProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
    }

    show = () => {
        this.setState({ show: true });
    };

    hide = () => {
        this.setState({ show: false });
    };

    render() {
        if (!this.props.member) {
            return <></>;
        }

        const member = this.props.member;
        const memberUser = member.user;
        let displayName = memberUser.display_name;
        const currentRank = memberUser.rank;
        const playerStats = memberUser.player_stats;
        const rankedStats = memberUser.ranked_stats;

        return <><Modal
            id={'profile-modal'}
            className={'profile-modal'}
            show={this.state.show}
            onHide={this.hide}
            onClick={this.hide}
            animation
            centered
            contentClassName={'profile-modal'}
        >
            <Modal.Body className={'profile-modal'}>

                <div className={'d-flex align-items-center justify-content-center flex-column'}>
                    <div className={'profile-circle'}>{currentRank}</div>
                    <h3>{displayName}</h3>
                    <Table className={'profile-stats'}>
                        <thead>
                        <tr>
                            <th>Rounds Played</th>
                            <th>Games Played</th>
                            <th>Games Won</th>
                            <th>Games Tied</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{playerStats.rounds_played}</td>
                            <td>{playerStats.games_played}</td>
                            <td>{playerStats.games_won}</td>
                            <td>{playerStats.games_tied}</td>
                        </tr>
                        </tbody>
                    </Table>
                    <hr/>
                    <h4>Ranked</h4>
                    <Table className={'profile-stats'}>
                        <thead>
                        <tr>
                            <th>Rounds Played</th>
                            <th>Games Played</th>
                            <th>Games Won</th>
                            <th>Games Tied</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{rankedStats.rounds_played}</td>
                            <td>{rankedStats.games_played}</td>
                            <td>{rankedStats.games_won}</td>
                            <td>{rankedStats.games_tied}</td>
                        </tr>
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
        </Modal>
        </>;
    }

}


export default class PlayerProfile extends Component {
    // Discord context so getLocalDisplayName resolves the local user's
    // real name (nick → global_name → @handle) rather than the
    // discord_<snowflake> username.
    static contextType = DiscordContext;

    constructor(props) {
        super(props);
        this.state = {
            profile: props.app.game.groupHandler.memberRecord.user,
            show: false
        };
    }

    componentDidMount() {
        window.addEventListener('group-update-event',
            this.receiveProfile);
        window.addEventListener('show-profile-event',
            this.show);
        window.addEventListener('hide-profile-event',
            this.hide);
    }

    componentWillUnmount() {
        window.removeEventListener('group-update-event',
            this.receiveProfile);
        window.removeEventListener('show-profile-event',
            this.show);
        window.removeEventListener('hide-profile-event',
            this.hide);
    }

    receiveProfile = (e) => {
        let profile = e.detail.member.user;
        this.setState({ profile: profile });
    };

    show = () => {
        this.setState({ show: true });
    };

    hide = () => {
        this.setState({ show: false });
    };

    render() {
        if (!this.state.profile) {
            return <></>;
        }

        let displayName = getLocalDisplayName(this.props.app, this.context);
        const currentRank = this.state.profile.rank;
        // Phase 0.5 (2026-04-11): server-side UserSerializer now returns
        // null for player_stats / ranked_stats when the user has no
        // Player chain (e.g. admin created via createsuperuser before
        // the login-time backfill existed). Guard with empty defaults
        // so render doesn't crash — the table just shows zeros.
        const EMPTY_STATS = {
            rounds_played: 0,
            games_played: 0,
            games_won: 0,
            games_tied: 0,
        };
        const playerStats = this.state.profile.player_stats || EMPTY_STATS;
        const rankedStats = this.state.profile.ranked_stats || EMPTY_STATS;

        return <><Modal
            id={'profile-modal'}
            className={'profile-modal'}
            show={this.state.show}
            onHide={this.hide}
            onClick={this.hide}
            animation
            centered
            contentClassName={'profile-modal'}
        >
            <Modal.Body className={'profile-modal'}>

                <div className={'d-flex align-items-center justify-content-center flex-column'}>
                    <div className={'profile-circle'}>{currentRank}</div>
                    <h3>{displayName}</h3>
                    <Table className={'profile-stats'}>
                        <thead>
                        <tr>
                            <th>Rounds Played</th>
                            <th>Games Played</th>
                            <th>Games Won</th>
                            <th>Games Tied</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{playerStats.rounds_played}</td>
                            <td>{playerStats.games_played}</td>
                            <td>{playerStats.games_won}</td>
                            <td>{playerStats.games_tied}</td>
                        </tr>
                        </tbody>
                    </Table>
                    <hr/>
                    <h4>Ranked</h4>
                    <Table className={'profile-stats'}>
                        <thead>
                        <tr>
                            <th>Rounds Played</th>
                            <th>Games Played</th>
                            <th>Games Won</th>
                            <th>Games Tied</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{rankedStats.rounds_played}</td>
                            <td>{rankedStats.games_played}</td>
                            <td>{rankedStats.games_won}</td>
                            <td>{rankedStats.games_tied}</td>
                        </tr>
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
        </Modal>
        </>;
    }

}
